import { Collapse, Spin, Typography } from "antd";
import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import FeedbackModal from "../../bond/components/FeedbackModal";
import { apiConfig } from "../../treasury.config";
import { Util } from "../helper/helper";
import PreviewTable from "./PreviewTable";
import SectionCard from "./SectionCard";
const { Text, Link, Title, Paragraph } = Typography;

function Preview({ setActivePage, activePage, data, id, template, userData }) {
  const { session } = userData;
  const navigate = useNavigate();
  const [tab, setTab] = React.useState(1);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const symbol = Util.getSymbol(template, data);

  const formData = data;
  console.log(formData);
  const allBranchesSelected = formData.restrictedOffice.find(
    (item) => item === 0
  );
  function goBack() {
    setActivePage(activePage - 1);
  }

  //  --THE MAPPINGS ARE TO GET THE LABEL OF EACH *SELCT* FIELD TO DISPLAY AS THEIR ACTUAL VALUES ARE NOT HANDCODED VALUES--

  const dataSections = [
    {
      header: "Product Information",
      items: [
        { name: "Product Code", labelValue: formData.productCode, type: 1 },
        { name: "Product Name", labelValue: formData.productName, type: 1 },
        {
          name: "Product Category",
          labelValue: Util.mapFormFieldToLabel(
            "productCategories",
            formData?.productCategory,
            template
          ),
        },
        {
          name: "Currency",
          labelValue: Util.mapFormFieldToLabel(
            "currencies",
            formData?.currencyCode,
            template
          ),
        },
        {
          name: "Branch Restriction",
          // labelValue: Util.mapFormFieldToLabel(
          //   "restrictions",
          //   formData.restrictedOffice,
          //   template
          // ),
          type: allBranchesSelected === 0 ? undefined : 3,
          labelValue: allBranchesSelected === 0 ? "All Branches" : undefined,
          items:
            allBranchesSelected === 0
              ? undefined
              : formData?.restrictedOffice.map((item, i) => {
                  return {
                    labelValue: Util.mapFormFieldToLabel(
                      "restrictions",
                      item,
                      template
                    ),
                  };
                }),
        },
        {
          name: "Accounting Classification",
          labelValue: Util.mapFormFieldToLabel(
            "accountingClassifications",
            formData?.accountingClassification,
            template
          ),
        },
        {
          name: "Custodian",
          labelValue: Util.mapFormFieldToLabel(
            "custodians",
            formData?.custodian,
            template
          ),
        },
        {
          name: "Start Date",
          labelValue: Util.formatFullDate(formData?.startDate),
        },
        {
          name: "End Date",
          labelValue: Util.formatFullDate(formData?.endDate),
        },
      ],
    },
    {
      header: "Instrument Parameters",
      items: [
        {
          name: "Instrument",
          labelValue: Util.mapFormFieldToLabel(
            "instrumentTypes",
            formData?.instrumentType,
            template
          ),
        },
        {
          name: "Issuer",
          labelValue: Util.mapFormFieldToLabel(
            "issuers",
            formData?.issuer,
            template
          ),
        },
        {
          name: "Security Type",
          labelValue: Util.mapFormFieldToLabel(
            "securityTypes",
            formData?.securityType,
            template
          ),
        },
        {
          name: "Tenors Supported",
          labelValue: Util.mapFormFieldToLabel(
            "tenorOptions",
            formData?.tenor,
            template
          ),
        },
        {
          name: "Minimum Investment",
          labelValue: formData?.minInvestment?.toLocaleString(),
          type: 1,
          prefix: symbol,
        },
        {
          name: "Default Investment",
          labelValue: formData?.maxInvestment,
          type: 1,
          prefix: symbol,
        },
        {
          name: "Investment Increment",
          labelValue: formData?.incrInvestment,
          type: 1,
          prefix: symbol,
        },
        {
          name: "Interest Type",
          labelValue: Util.mapFormFieldToLabel(
            "interestTypes",
            formData?.treasuryBillInterestType,
            template
          ),
        },
        {
          name: "Redemption Mode",
          labelValue: Util.mapFormFieldToLabel(
            "redemptionModes",
            formData?.redemptionMode,
            template
          ),
        },
        {
          name: "Allow Early Redemption",
          labelValue: formData?.allowEarlyRedemption ? "Yes" : "No",
          type: 2,
        },
      ],
    },
    {
      header: "Price and Rate Settings",
      items: [
        {
          name: "Pricing Method",
          labelValue: Util.mapFormFieldToLabel(
            "pricingMethods",
            formData?.pricingMethod,
            template
          ),
        },
        {
          name: "Pricing Frequency",
          labelValue: Util.mapFormFieldToLabel(
            "pricingFrequencies",
            formData?.pricingFrequency,
            template
          ),
        },
        {
          name: "Discount Rate",
          labelValue: formData?.discountRate,
          type: 1,
          suffix: "%",
        },
        {
          name: "Interest Rate Source",
          labelValue: Util.mapFormFieldToLabel(
            "rateSourceOptions",
            formData?.interestRateSource,
            template
          ),
        },
        {
          name: "Interest Rate Basis",
          labelValue: Util.mapFormFieldToLabel(
            "interestCalculationBasisOptions",
            formData?.interestCalculationBasis,
            template
          ),
        },
        {
          name: "Accrual Method",
          labelValue: Util.mapFormFieldToLabel(
            "accrualMethodOptions",
            formData?.accrualMethod,
            template
          ),
        },
      ],
    },
    {
      header: "Maturity Settings",
      items: [
        {
          name: "Debit Source Account",
          labelValue: Util.mapFormFieldToLabel(
            "debitSourceAccountTypeOptions",
            formData?.debitSourceAccountType,
            template
          ),
        },
        {
          name: "Settlement Date",
          labelValue: Util.mapFormFieldToLabel(
            "settlementDateTypes",
            formData?.settlementDate,
            template
          ),
        },
        {
          name: "Maturity Proceeds",
          labelValue: Util.mapFormFieldToLabel(
            "maturityProceeds",
            formData?.maturityProceed,
            template
          ),
        },
        {
          name: "Rollover Option",
          type: 3,
          items: [
            {
              labelValue: formData?.allowRollover ? "Yes" : "No",
            },
            formData.allowRollover
              ? {
                  labelValue:
                    formData?.autoRollover === false ? "Manual" : "Auto",
                }
              : null,
          ],
        },
      ],
    },
    {
      header: "Tax & Charges",
      items: [
        {
          name: "Tax Group",
          type: 3,
          items: [
            {
              labelValue: formData?.allowTax ? "Yes" : "No",
            },
            formData?.taxGroup
              ? {
                  labelValue: Util.mapFormFieldToLabel(
                    "taxGroupOptions",
                    formData?.taxGroup,
                    template
                  ),
                }
              : null,
          ],
        },
        {
          name: "Setup Charges",
          type: 3,
          items: [
            {
              labelValue: formData?.setupCharges ? "Yes" : "No",
            },
            formData?.setupCharges
              ? {
                  labelValue: Util.mapFormFieldToLabel(
                    "chargeOptions",
                    formData?.setupCharge,
                    template
                  ),
                }
              : null,
          ],
        },
        {
          name: "Redemption Charges",
          type: 3,
          items: [
            {
              labelValue: formData?.redemptionCharges ? "Yes" : "No",
            },
            formData?.redemptionCharges
              ? {
                  labelValue: Util.mapFormFieldToLabel(
                    "chargeOptions",
                    formData?.redemptionCharge,
                    template
                  ),
                }
              : null,
          ],
        },
        {
          name: "Transfer Charges",
          type: 3,
          items: [
            {
              labelValue: formData?.transferCharges ? "Yes" : "No",
            },
            formData?.transferCharges
              ? {
                  labelValue: Util.mapFormFieldToLabel(
                    "chargeOptions",
                    formData?.transferCharge,
                    template
                  ),
                }
              : null,
          ],
        },
        {
          name: "Brokerage/Agent Commission",
          type: 3,
          items: [
            {
              labelValue: formData?.allowBrokerage ? "Yes" : "No",
            },
            formData?.allowBrokerage
              ? {
                  labelValue: Util.mapFormFieldToLabel(
                    "chargeOptions",
                    formData?.commission,
                    template
                  ),
                }
              : null,
          ],
        },
      ],
    },
    {
      header: "Accounting Settings",
      items: [
        {
          name: "Investment - Deal Booking",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.investmentDealBookingDebit,
                template
              ),
            },
            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.investmentDealBookingCredit,
                template
              ),
            },
          ],
        },
        {
          name: "Interest Accrual Posting",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.interestAccrualDebit,
                template
              ),
            },

            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.interestAccrualCredit,
                template
              ),
            },
          ],
        },

        {
          name: "Investment - Redemption (Customer Payable)",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.investmentRedemptionDebit,
                template
              ),
            },
            {
              labelValue: Util.mapFormFieldToLabel(
                "assetGLAccounts",
                formData?.investmentRedemptionCredit,
                template
              ),
            },
          ],
        },
        {
          name: "Income Interest Posting",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomeInterestDebit,
                template
              ),
            },
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomeInterestCredit,
                template
              ),
            },
          ],
        },

        {
          name: "Income Fees Posting",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomeFeesDebit,
                template
              ),
            },
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomeFeesCredit,
                template
              ),
            },
          ],
        },
        {
          name: "Income Penalty Posting",
          type: 3,
          items: [
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomePenaltyDebit,
                template
              ),
            },
            {
              labelValue: Util.mapFormFieldToLabel(
                "incomeGLAccounts",
                formData?.incomePenaltyCredit,
                template
              ),
            },
          ],
        },
      ],
    },
    // {
    //   header: "Accounting Settings",
    //   items: [
    //     {
    //       name: "Investment - Deal Booking",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "investmentDealBooking",
    //         formData.investmentDealBooking,
    //         template
    //       ),
    //     },
    //     {
    //       name: "Interest Accrual Posting",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "interestAccrualPosting",
    //         formData.interestAccrualPosting,
    //         template
    //       ),
    //     },
    //     {
    //       name: "Investment - Redemption(Customer Payable)",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "investmentRedemption",
    //         formData.investmentRedemption,
    //         template
    //       ),
    //     },
    //     {
    //       name: "Income Interest Posting",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "incomeInterestPosting",
    //         formData.incomeInterestPosting,
    //         template
    //       ),
    //     },
    //     {
    //       name: "Income Fees Posting",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "incomeFeesPosting",
    //         formData.incomeFeesPosting,
    //         template
    //       ),
    //     },
    //     {
    //       name: "Income Penalty Posting",
    //       labelValue: Util.mapFormFieldToLabel(
    //         "incomePenalityPosting",
    //         formData.incomePenalityPosting,
    //         template
    //       ),
    //     },
    //   ],
    // },
  ];

  const onSubmit = () => {
    console.log(formData);

    const finalData = { ...formData };
    finalData.investmentGL = [
      finalData.investmentDealBookingDebit,
      finalData.investmentDealBookingCredit,
    ];
    finalData.accruedInterestGL = [
      finalData.interestAccrualDebit,
      finalData.interestAccrualCredit,
    ];
    finalData.settlementGL = [
      finalData.investmentRedemptionDebit,
      finalData.investmentRedemptionCredit,
    ]; //Investment - Redemption (Customer Payable)
    finalData.interestIncomeGL = [
      finalData.incomeInterestDebit,
      finalData.incomeInterestCredit,
    ]; // Income Interest Posting
    finalData.principalGL = [
      finalData.incomeFeesDebit,
      finalData.incomeFeesCredit,
    ]; // Income Fees Posting
    finalData.penaltyGL = [
      finalData.incomePenaltyDebit,
      finalData.incomePenaltyCredit,
    ]; //            Income Fees Posting
    finalData.startDate = BOM.DateTime(finalData.startDate, "only-date");
    finalData.endDate = BOM.DateTime(finalData.endDate, "only-date");
    // finalData.autoRollover = formData.rolloverOption === 1 ? false : true;

    delete finalData.investmentDealBookingDebit;
    delete finalData.investmentDealBookingCredit;
    delete finalData.interestAccrualCredit;
    delete finalData.interestAccrualDebit;
    delete finalData.incomeInterestCredit;
    delete finalData.incomeInterestDebit;
    delete finalData.investmentRedemptionCredit;
    delete finalData.investmentRedemptionDebit;
    delete finalData.incomeFeesCredit;
    delete finalData.incomeFeesDebit;
    delete finalData.incomePenaltyDebit;
    delete finalData.incomePenaltyCredit;
    delete finalData.settlementDate;
    delete finalData.rolloverOption;
    delete finalData.id;
    delete finalData.status;
    delete finalData.currency;
    delete finalData.interestType;
    // delete finalData.settlementDateType;
    // delete finalData.restrictedOffice;
    delete finalData.interestRate;
    delete finalData.discountRateSource;

    // if (!finalData.allowRollover) {
    //   delete finalData.autoRollover;
    // }

    const restrictedOffice =
      allBranchesSelected === 0
        ? template?.restrictions?.map((item) => item.value)
        : formData.restrictedOffice;

    const body = {
      ...finalData,
      restrictedOffice,
      restriction: undefined,
      instrument: undefined,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: id ? "PUT" : "POST",
      settlementDateType: finalData.settlementDate,
      session,
    };

    setLoading(true);
    if (id) {
      const url = `${apiConfig.TreasuryBillProduct}/${id}`;
      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setLoading(false);
        } else {
          setShowSuccessModal(true);
          setLoading(false);
        }
      });
      return;
    }
    BOM.FetchReqAction(body, apiConfig.TreasuryBillAddProduct, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setLoading(false);
      } else {
        setShowSuccessModal(true);
        // BOM.AlertMsg(cnt.SUCCESS, labelConfig.newCurrentAccountMsg);
        // navigate("/detail-current-account", {
        //   state: {
        //     id: res.resourceId,
        //     statusValue: accountStatus.submittedAndPending,
        //   },
        // });

        //STOP LOAD
        setLoading(false);
      }
    });
  };

  const finalData = dataSections.map((item, i) => {
    return {
      key: i,
      label: (
        <div style={{}}>
          <Text style={{ fontSize: 16 }}>{item.header}</Text>
        </div>
      ),
      children: <PreviewTable data={item.items} />,
      showArrow: false,
    };
  });

  // const onSubmit = () => {
  //   setShowSuccessModal(true);
  // };

  const handleClose = () => {
    setShowSuccessModal(false);
  };
  function onCancel() {
    navigate("/treasury-bill", { replace: false });
  }
  // const items = [
  //   {
  //     key: "1",
  //     label: "This is panel header 1",
  //     children: (
  //       <PreviewTable finalData={dataSections[0].items} />
  //       // <Table
  //       //   showHeader={false}
  //       //   columns={columns}
  //       //   dataSource={dataSections[0].items}
  //       //   bordered
  //       //   pagination={false}
  //       //   rowClassName={{}}
  //       // />
  //     ),
  //     showArrow: false,
  //   },
  //   {
  //     key: "2",
  //     label: "This is panel header 2",
  //     children: <p>aoka</p>,
  //     showArrow: false,
  //   },
  //   {
  //     key: "3",
  //     label: "This is panel header 3",
  //     children: <p>aoka</p>,
  //     showArrow: false,
  //   },
  // ];

  return (
    <SectionCard
      onPrev={goBack}
      nextTitle={id ? "Update Product" : "Create Product"}
      onNext={onSubmit}

      // style={{
      //   padding: 0,
      //   border: "none",
      //   borderRadius: 20,
      //   overflowX: "hidden",
      //   overflowY: "auto",
      //   height: "720px",
      //   // maxHeight: "80vh",
      //   // overflow: "scroll",
      // }}
    >
      <Spin spinning={loading} size="large">
        <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
          Preview
        </Title>
        <Text style={{ color: "#344054" }} color="#344054">
          Description text
        </Text>
        <div className="add-treasury-bill-collapsible">
          <Collapse
            bordered={false}
            // expandIcon={<CaretDownIcon />}
            ghost={true}
            style={{ marginTop: 20, border: 0 }}
            items={finalData}
            defaultActiveKey={[0, 1, 2, 3, 4, 5]}
            // expandIconPosition="right"
          />
        </div>

        {/* <div>
        {dataSections.map((item,i) => {

        })}
      </div> */}
        {/* <Row style={{ gap: 10, marginTop: 50 }} align={"end"}>
          <Button onClick={goBack} size="large">
            Previous
          </Button>
          <Button
            onClick={onSubmit}
            size="large"
            style={{
              backgroundColor: "#15CCAE",
              color: "white",
              borderWidth: 0,
            }}
          >
            {id ? "Update Product" : "Create Product"}
          </Button>
        </Row> */}
        {/* <SavedChangesModal visible /> */}
        {/* Success Modal */}
        <FeedbackModal
          message={
            id && "Your Money Market Product has been updated successfully."
          }
          visible={showSuccessModal}
          type="success"
          primaryButtonText={"Done"}
          onPrimaryAction={onCancel}
          onSecondaryAction={() => {
            onCancel();
          }}
          onClose={handleClose}
        />
      </Spin>
    </SectionCard>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
